import styled from '@emotion/styled';
import React from 'react';

interface IProps {
  children: string;
  href: string;
  isActive: boolean;
  onClick: (e: any) => void;
}

const Host = styled.a<{ isActive: boolean; onClick: any }>`
  display: block;
  padding-left: 28px;
  margin-left: -2px;
  line-height: calc(32 / 18);
  opacity: ${({ isActive }) => (isActive ? 1 : 0.5)};

  border-left: ${(props) =>
    props.isActive
      ? `2px solid ${props.theme.colors.primary}`
      : '2px solid transparent'};

  transition: opacity 200ms ease-in-out, border-color 200ms ease-in-out;
`;

export const NavItem = ({ children, href, isActive, onClick }: IProps) => {
  return (
    <Host href={href} title={children} isActive={isActive} onClick={onClick}>
      {children}
    </Host>
  );
};
